import React from 'react';

function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="content has-text-centered">
                    <p>
                        Footer footer footer
                        <br />
                        <a href="/#">Terms of service</a> |
                        <a href="/#">Privacy Policy</a>
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
